import { getEnv, setEnv, Env } from '../lib/env';

/**
 * Live/Dev pills. Switching reloads so every component drops tier-specific
 * cached data at once — same reasoning as the legacy panel's hard reload.
 */
export function EnvSwitch() {
  const env = getEnv();
  const choose = (next: Env) => {
    if (next === env) return;
    setEnv(next);
    location.reload();
  };
  return (
    <div className="env-switch" role="group" aria-label="Backend environment">
      {(['live', 'dev'] as Env[]).map((e) => (
        <button
          key={e}
          type="button"
          data-env={e}
          className={'env-pill' + (env === e ? ' on' : '')}
          onClick={() => choose(e)}
        >
          {e === 'live' ? 'Live' : 'Dev'}
        </button>
      ))}
    </div>
  );
}

export function EnvBadge() {
  return getEnv() === 'dev' ? <div className="env-badge">DEV API</div> : null;
}
